module.exports = __webpack_public_path__ + "media/newstyle/images/icon-open-chart-orange-2ea60df2c6b6f5147461b8a4ff022627.svg";